import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import {PageHeadingWrapper} from "../styles/PageStyles";
import AlertsCard from "../components/notfications/AlertsCard";
import AlertsCardsGroup from "../components/notfications/AlertsCardsGroup";
import {StaggeredMotion, spring} from "react-motion/lib/react-motion";
import {fillArray, filterObjectsBy, getCreationTime} from "../utils";
import CustomSearchField from "../components/common/CustomSearchField";
import {connect} from "react-redux"
import {removeAlert, setAlerts, updateAlert} from "../redux/actions/AlertsActions";
import {TransitionMotion} from "react-motion";
import LongPressListener from "../components/LongPressListener";
import IconActionButton2 from "../components/common/IconActionButton2";


import {ReactComponent as Seen} from "../assets/seen.svg";
import {ReactComponent as Unseen} from "../assets/unseen.svg";
import {ReactComponent as Bell} from "../assets/bell.svg";
import {ReactComponent as Flag} from "../assets/flag.svg";
import {ReactComponent as Bin} from "../assets/bin.svg";

import {ReactComponent as ContractIcon} from "../assets/notif-contract.svg";
import {groupAndSortItemsByFieldName} from "../utils/customersUtils";
import {capitalize} from "@material-ui/core/utils";

const testAlerts = [
    {
        id: "1",
        heading: "Document",
        body: "Letter of Undertaking for Ajaccio Investments Limited is due to expire in 2 weeks",
        seen: false,
        selected: false,
        timeCreated: new Date()
    },
    {
        id: "2",
        heading: "Document",
        body: "Letter of Undertaking for Ajaccio Investments Limited is due to expire in 2 weeks",
        seen: false,
        selected: false,
        timeCreated: new Date()
    },
    {
        id: "3",
        heading: "Document",
        body: "Letter of Undertaking for Ajaccio Investments Limited is due to expire in 2 weeks",
        seen: true,
        selected: false,
        timeCreated: new Date(2020, 0, 12)
    },
    {
        id: "4",
        heading: "Document",
        body: "Letter of Undertaking for Ajaccio Investments Limited is due to expire in 2 weeks",
        seen: true,
        selected: false,
        timeCreated: new Date()
    },
    {
        id: "5",
        heading: "Document",
        body: "Letter of Undertaking for Ajaccio Investments Limited is due to expire in 2 weeks",
        seen: true,
        selected: false,
        timeCreated: new Date()
    }
];

export const PageWrapper = styled.div`
    height: calc(100vh - var(--header-height));
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const PageContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    overflow: hidden;
`;

export const AlertsContent = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    padding: 0 32px;
`;

export const SidePanelContent = styled.div`
    display: flex;
    width: fit-content;
    flex-direction: column;        
    align-items: center;
    
    padding-top: 32px;
    padding-left: 8px;
`;

export const AlertsActionsWrapper = styled.div`
    width: 100%;
    margin-top: 24px;
    
    display: flex;
    align-content: start;
    flex-direction: column;
    
    > * {
      margin-bottom: 16px;
    }
`;



function AlertsPage(props) {

    const {alerts, setAlerts, removeAlert, updateAlert} = props;

    useEffect(() => {
        // Call service for alerts.
        // setAlerts(testAlerts)
    }, []);

    // --- States
    const [searchParams, setSearchParams] = useState("");
    const [isSearching, setSearching] = useState(false);


    // --- handlers
    const handleOnSearchChange = (e) => {
        const {value} = e.target;
        setSearchParams(value);
        if (isSearching) setSearching(false);
    };

    const handleOnSearchClick = () => {
        //TODO search notifications and filter results
        console.log("search clicked");
        setSearching(true);
    };

    const markAlertAsSeen = (alerts) => {
        const updatedItems = alerts.map(item => ({
            ...item,
            seen: true
        }));

        updatedItems.forEach(item => {
            updateAlert(item);
        })
    };

    const updateSelectedAlerts = (alerts, updates) => {
        const updatedItems = alerts.map(item => ({
            ...item,
            ...updates
        }));

        updatedItems.forEach(item => {
            updateAlert(item);
        })
    };

    const removeSelectedAlerts = (alerts) => {
        alerts.forEach(item => {
            removeAlert(item);
        });
    };


    // const processStyles = (prevInterpolatedStyles, isCollapsed) =>
    //     prevInterpolatedStyles.map((_, i) => ({
    //         height: spring((isCollapsed) ? 0 : 119, {stiffness: 100, damping: 17}),
    //         z: prevInterpolatedStyles.length - i,
    //         mb: spring(( isCollapsed && i > 1) ?  0: 16 ),
    //         opacity: spring( ( isCollapsed && i > 2) ? 0 : 100),
    //         width: spring((isCollapsed) ? (100 - (5 * i)) : 100)
    //     })
    // );

    const defaultNotificationStyle = {
        height: 0,
        z: 1,
        width: 100,
        opacity: 100,
        mb: 0
    };

    const configStyles = (items, isCollapsed, spring) => items.map((item, i) => ({
            key: item.id,
            data: item,
            style: {
                height: spring((isCollapsed) ? 0 : 119, {stiffness: 100, damping: 17}),
                z: items.length - i,
                mb: spring(( isCollapsed && i > 1) ?  0: 16 ),
                opacity: spring( ( isCollapsed && i > 2) ? 0 : 100),
                width: spring((isCollapsed) ? (100 - (5 * i)) : 100)
            }
        }));

    const getSelectedAlerts = (alerts) => alerts.filter(item => item.selected);



    // Manipulate data to be displayed.
    let alertsToDisplay = [...alerts];
    const selectedAlerts = getSelectedAlerts(alertsToDisplay);

    // filter alerts
    if (isSearching && searchParams) {
        alertsToDisplay = filterObjectsBy(alertsToDisplay, ["heading", "body"], searchParams)
    }

    // Create alerts group;
    const alertGroups = groupAndSortItemsByFieldName(alertsToDisplay, "heading");
    return (
        <PageWrapper>
            <PageHeadingWrapper>
                Notifications
            </PageHeadingWrapper>
            <PageContentWrapper>
                <AlertsContent>

                    {
                        Object.keys(alertGroups).map(key => {
                            const items = alertGroups[key];
                            const isSeen = items.every(item => item.seen );

                            const defaultStyles = items.map((item) => ({
                                key: item.id.toString(),
                                style: defaultNotificationStyle,
                                data: item,
                            }));

                            const willLeave = () => ({
                                opacity: spring(0),
                                height: spring(0)
                            });

                            return <AlertsCardsGroup
                                key={ key }
                                heading={ key }
                                seen={ isSeen }
                                collapsible={ items.length > 1 }
                                render={
                                    (collapsed) =>
                                        <>
                                            {
                                                <TransitionMotion
                                                    willLeave={willLeave}
                                                    defaultStyles={defaultStyles}
                                                    styles={configStyles(items, collapsed, spring)}
                                                >
                                                    {interpolatingStyles => {
                                                        return <>
                                                            {
                                                                interpolatingStyles.map((config, i) => {
                                                                    const {style, key, data} = config;
                                                                    const onClose = () => removeAlert(data);
                                                                    const onLongPress = (alert) => {
                                                                        // select or unselect the alert
                                                                        updateAlert({
                                                                            ...alert,
                                                                            selected: !alert.selected
                                                                        });
                                                                    };
                                                                    const onAlertClick = (alert) => {
                                                                        updateAlert({
                                                                            ...alert,
                                                                            seen: true
                                                                        });
                                                                    };


                                                                    return <div
                                                                        key={key}
                                                                        style={{
                                                                            height: style.height,
                                                                            marginBottom: style.mb,
                                                                            zIndex: style.z,
                                                                            opacity: style.opacity,
                                                                            width: `${style.width}%`
                                                                        }}
                                                                    >
                                                                        <LongPressListener
                                                                            onLongPressed={() => onLongPress(data, i)}
                                                                        >
                                                                            <AlertsCard
                                                                                key={i}
                                                                                isSelected={data.selected}
                                                                                seen={data.seen}
                                                                                collapsed={collapsed}
                                                                                heading={capitalize(data.type)}
                                                                                body={data.body}
                                                                                timeCreated={getCreationTime(data.timeCreated)}
                                                                                onClose={onClose}
                                                                                onClick={() => onAlertClick(data)}
                                                                                icon={<ContractIcon/>}
                                                                            />
                                                                        </LongPressListener>
                                                                    </div>
                                                                })
                                                            }
                                                        </>
                                                    }
                                                }
                                                </TransitionMotion>
                                            }
                                        </>
                                }

                            />
                        })
                    }
                </AlertsContent>

                <SidePanelContent>
                    <CustomSearchField
                        value={searchParams}
                        onSearchClick={handleOnSearchClick}
                        onSearchChange={handleOnSearchChange}
                        placeholder={"Search your Alerts"}
                    />

                    <AlertsActionsWrapper>
                        <IconActionButton2
                            onClick={() => markAlertAsSeen(getSelectedAlerts(alerts))}
                            icon={<Seen/>}>
                            Mark as Seen
                        </IconActionButton2>

                        <IconActionButton2
                            onClick={() => updateSelectedAlerts(getSelectedAlerts(alerts), {seen: false})}
                            icon={<Unseen/>}>
                            Mark as Unseen
                        </IconActionButton2>

                        <IconActionButton2
                            onClick={() => updateSelectedAlerts(getSelectedAlerts(alerts), {seen: false})}
                            icon={<Bell/>}>
                            Alert Representatives
                        </IconActionButton2>

                        <IconActionButton2
                            onClick={() => updateSelectedAlerts(getSelectedAlerts(alerts), {flag: false})}
                            icon={<Flag/>}>
                            Flag Selected
                        </IconActionButton2>

                        <IconActionButton2
                            onClick={() => removeSelectedAlerts(getSelectedAlerts(alerts))}
                            icon={<Bin/>}>
                            Delete Selected
                        </IconActionButton2>

                        {
                            selectedAlerts.length > 0 &&
                            <IconActionButton2
                                onClick={() => updateSelectedAlerts(getSelectedAlerts(alerts), {selected: false})}>
                                Unselect All {/*{ `${ selectedAlerts.length > 0 ? `${selectedAlerts.length} alerts` : "" }` }*/}
                            </IconActionButton2>
                        }

                    </AlertsActionsWrapper>
                </SidePanelContent>
            </PageContentWrapper>
        </PageWrapper>
    );
}

AlertsPage.propTypes = {};
AlertsPage.defaultProps = {};

const mapDispatchToProps = {
    setAlerts,
    removeAlert,
    updateAlert,
};

const mapStateToProps = (state) => {
    return {
        alerts: state.alerts
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertsPage);
